
const getters = {
    token: state => state.user.token,
    TokenInfo: state => state.user.TokenInfo,
}
// console.log('获取tiken',getters.token)
export default getters